import { InjectionToken } from '@angular/core';

/**
 * @description    Create a simple date from the date object
 * @param dateObj  Date object
 * @param locale   Locale used to format the date
 */
export const getShortMonthYearDate = (dateObj: Date, locale: string): string => {
    const month = dateObj.toLocaleDateString(locale, { month: 'short' });
    const year = dateObj.toLocaleDateString(locale, { year: '2-digit' });

    return month + year;
};

export type GetShortMonthYearDateProvider = (dateObj: Date, locale: string) => string;
export const GET_SHORT_MONTH_YEAR_DATE =
    new InjectionToken('GET_SHORT_MONTH_YEAR_DATE', {
        factory: () => getShortMonthYearDate
    });
